<template>
  <svg :height="size" :width="size" fill="none" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
    <path
      :stroke="color"
      d="M14.5857 9.82157L11.8096 12.5977C11.0285 13.3787 11.0285 14.6451 11.8096 15.4261L14.5857 18.2022C15.3667 18.9833 16.6331 18.9833 17.4141 18.2022L20.1902 15.4261C20.9713 14.6451 20.9713 13.3787 20.1902 12.5977L17.4141 9.82157C16.6331 9.04052 15.3667 9.04052 14.5857 9.82157Z"
      stroke-linecap="round"
      stroke-miterlimit="10"
      stroke-width="2"
    />
    <path
      :fill="color"
      d="M24 29.6C24 25.6 20.1177 23.8801 16.0006 23.8801C11.8831 23.8801 8 25.6 8 29.6C8 29.6 9.02816 32 16.0006 32C22.9731 32 24 29.6 24 29.6Z"
    />
  </svg>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "EdroneAvatarRhomb",
  props: {
    size: {
      type: Number,
      default: 32,
    },
    color: {
      type: String,
      default: "#545454",
    },
  },
});
</script>

<style scoped></style>
